import InputButton from 'components/form/inputButton'
import InputDropdown from 'components/form/inputDropdown'
import InputText from 'components/form/inputText'
import React, { Component } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import '../StockPopup.scss'
import { optionShow, stockFields } from './DisplayFields'

class StockDisplay extends Component {
	constructor(props) {
		super(props)
		this.state = {
			cantPendent: 0,
			cantAffect: 0
		}
	}

	componentDidUpdate = (prevProps) => {
		const { productStock, validateStock, searchItems } = this.props
		if (productStock !== prevProps.productStock && productStock) {
			this.handleSetTotals(productStock)
		}

		if (validateStock !== prevProps.validateStock && validateStock) {
			this.handleSetTotals(validateStock)
		}

		if (searchItems !== prevProps.searchItems && searchItems) {
			this.handleSetTotals(searchItems)
		}
	}

	handleSetTotals = (totals) => {
		this.setState({
			cantPendent: totals.cant_pend,
			cantAffect: totals.cant_afec
		})
	}

	render() {
		const { t, productStock } = this.props
		const { cantPendent, cantAffect } = this.state

		const descProd = productStock ? productStock.descr_prod : ''
		const presentProd =
			productStock && productStock.presentacion ? productStock.presentacion : ''

		const uniVta = productStock ? productStock.unid_vta : ''

		return (
			<Container className={`containerDisplay`}>
				<Row>
					<Col lg={9} md={12} className={`contentDisplay`}>
						<Row>
							<InputText
								inputFormCol={{ lg: 12, md: 12 }}
								fields={stockFields}
								label={'label'}
								inputId={'product_name'}
								name={'product_name'}
								placeholder={''}
								styles={{ width: '100%' }}
								colLabel={'col-lg-2 col-md-3'}
								colInput={'col-lg-10 col-md-9'}
								disable={true}
								onBlur={() => {}}
								value={descProd}
								onChange={() => {}}
								divStyle={{}}
							/>
							<InputText
								inputFormCol={{ lg: 12, md: 12 }}
								fields={stockFields}
								label={'label'}
								inputId={'product_presentation'}
								name={'product_presentation'}
								placeholder={''}
								styles={{ width: '100%' }}
								colLabel={'col-lg-2 col-md-3'}
								colInput={'col-lg-10 col-md-9'}
								disable={true}
								onBlur={() => {}}
								value={presentProd}
								onChange={() => {}}
								divStyle={{}}
							/>

							<Col sm={2}>{t('Stock.pending')}</Col>
							<Col sm={4} className={'text-left'}>
								{`${cantPendent} ${uniVta}`}
							</Col>
							<Col sm={2}>{t('Stock.affected')}</Col>
							<Col sm={4} className={'text-left'}>
								{`${cantAffect} ${uniVta}`}
							</Col>
						</Row>
					</Col>
					<Col lg={3} md={12} className={'text-center pt-2'}>
						<Row>
							<Col lg={12} md={6} className={'text-right  mb-3 mt-2'}>
								<InputButton
									valueButton={t('Collection.form.buttons.accept')}
									type={'primary'}
									onClick={() => this.props.handleConfirmStock()}
									customStyle={{ minWidth: '125px' }}
								/>
							</Col>
							<Col lg={12} md={6} className={'text-right mb-3 mt-2'}>
								<InputButton
									valueButton={t('Collection.form.buttons.cancel')}
									type={'primary'}
									onClick={() => this.props.handleCancelStock()}
									customStyle={{ minWidth: '125px' }}
								/>
							</Col>
						</Row>
						<Col sm={12} className={'text-right mt-2'}>
							<Row>
								<Col sm={4}>{t('Stock.show')}</Col>
								<InputDropdown
									inputFormCol={{ sm: 8 }}
									noInitialExecute
									fields={stockFields}
									label={false}
									inputId={'product_filtro'}
									name={'product_filtro'}
									styles={{ width: '100%' }}
									options={optionShow}
									onChange={(filter) =>
										this.props.handleChangeFilter(filter.target.value)
									}
								/>
							</Row>
						</Col>
					</Col>
				</Row>
			</Container>
		)
	}
}

const mapStateToProps = ({ stock }) => {
	const { productStock, loadStock, applyStock, searchItems } = stock
	return {
		productStock,
		loadStock,
		applyStock,
		searchItems
	}
}

const mapDispatchToProps = {}

const connectForm = connect(mapStateToProps, mapDispatchToProps)(StockDisplay)

export default withTranslation()(connectForm)
